// extracted by mini-css-extract-plugin
module.exports = {"box":"Home_box__2B9BV"};